import { render } from "./PaymentFailedModal.vue?vue&type=template&id=6f5e62f1"
import script from "./PaymentFailedModal.vue?vue&type=script&lang=js"
export * from "./PaymentFailedModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__